<template>
  <div>
    <page-breadcrumb :title="currentSite.name" :routes="routes"/>
    <div class="vx-row" v-if="datas.length > 0">
      <div
        class="vx-col w-full mb-8 md:w-1/2 lg:w-1/2 xl:w-1/2"
        v-for="(areaData, idx) in datas"
        :key="idx"
      >
        <site-cards
          :title="areaData.name"
          :slug="$route.params.slug + '/' + areaData.id"
          :inData="areaData.countIn"
          :outData="areaData.countOut"
          :totalData="areaData.countTotal"
        />
      </div>
    </div>
    <div class="vx-row" v-else>
      <div class="vx-col w-full mb-8">
        <h2>No Area Found</h2>
      </div>
    </div>
  </div>
</template>

<script>
import SiteCards from "../components/site-cards/index.vue";
import PageBreadcrumb from "../components/PageBreadcrumb.vue";
import api from "../api";

export default {
  data() {
    return {
      datas: []
    };
  },
  computed: {
    site() {
      return this.$store.state.sites;
    },
    currentSite() {
      return this.$store.state.currentSite;
    },
    routes() {
      return {
        ...this.$route,
        meta: {
          ...this.$route.meta,
          breadcrumb: [
            { title: "Dashboard", url: "/" },
            { title: this.currentSite.name, active: true },
          ]
        }
      }
    }
  },
  components: { SiteCards,PageBreadcrumb },
  created() {
    this.$vs.loading();
    this.getAreaLists();
    this.repeatFetahData(false);
  },
  beforeMount() {
    const currentSite = this.site.find(v => v.id == this.$route.params.slug);
    this.$store.dispatch('updateCurrentSite', currentSite);
  },
  methods: {
    repeatFetahData() {
      const self = this;
      setInterval(function () {
        self.getAreaLists(true);
      }, 60000); // 1 menit
    },
    getAreaLists(repeated) {
      api
        .areaLists({ SiteId: this.$route.params.slug })
        .then((result) => result.data.data)
        .then((data) => {
          this.datas = data;
          this.$vs.loading.close();
          if(!repeated) {
            this.$store.dispatch('updateAreaLists', data);
          }
        });
    },
  },
};
</script>
